import styles from '../Table.module.scss';
import { Header } from '@tanstack/react-table';
import { CrossIcon } from '@/components/base/Icons/RocheIconPack';
import { UserGroupIcon } from '@/components/base/Icons/UserGroupIcon';

type GroupingIndicatorProps<T> = {
  header: Header<T, unknown>;
};

const GroupingIndicator = <T,>({ header }: GroupingIndicatorProps<T>) => {
  const groupable = header.column.getCanGroup();
  const isGrouped = header.column.getIsGrouped();

  if (!groupable) return null;

  const GroupingIcon = isGrouped ? CrossIcon : UserGroupIcon;

  return (
    <div onClick={header.column.getToggleGroupingHandler()} className={styles.groupable}>
      <GroupingIcon width={'2rem'} />
    </div>
  );
};

export default GroupingIndicator;
